import classnames from 'classnames';
import React from 'react';
import { getThumbnailMinWidthAttribute } from '../get-thumbnail-min-width-attribute';
import styles from './wrapper.scss';
export const SliderWrapper = _ref => {
  let {
    className,
    ariaLabel,
    children,
    onRef,
    itemWidth,
    isRTL,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement("section", {
    style: style,
    className: classnames(styles.container, className),
    ref: onRef,
    "aria-label": ariaLabel,
    tabIndex: 0,
    "data-thumbnail-min-width": getThumbnailMinWidthAttribute(itemWidth),
    "data-hook": "video-list",
    dir: isRTL ? 'rtl' : 'ltr'
  }, children);
};
//# sourceMappingURL=wrapper.js.map